// ResetPortfolioModal.js
import React from 'react';
import PageContainer from '../pages/PageContainer';
import GameSideBar from '../Games/GameSideBar';

const ResetPortfolioModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null; // Don't render anything if the modal is not open

  return (
    <>

        <div className="fixed z-50 inset-0 overflow-y-auto">
      <div className="flex items-center justify-center px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <div className="flex items-center justify-center fixed z-50 inset-0 overflow-y-auto">
          <div className="w-full flex items-center justify-center pt-4 pb-20 text-center sm:block sm:p-0">
            <div className="bg-white rounded-lg shadow-xl max-w-lg mx-auto sm:my-8 p-6">
              <div className="flex justify-between">
                <div></div>
              </div>
              <h2 className="text-lg font-bold text-primaryColor mb-4">
                QUSHi Bank
              </h2>
              {/* Please note that reset will clear all your portfolio data and your account will work like a fresh account and you will get  $1000,000 credits to start.
              <br /><br /> You will be charged $4.99 for resetting your account. */}
              QUSHi Bank allows you to reset your portfolio for $4.99. This will give you a new million dollar account, start date, and track record. This reset will not affect your content or saved charts. Learning from your mistakes is a crucial part of your journey toward becoming a consistent professional. Climb that leaderboard!
            <div className="flex items-center justify-center space-x-4 mt-6"> {/* Add space between buttons */}
              <button
                className="w-32 bg-primaryColor hover:bg-primaryColor text-white font-bold py-2 px-3 rounded-full focus:outline-none focus:shadow-outline"
                onClick={onConfirm}
              >
                Confirm
              </button>
              <button
                className="w-32 bg-primaryColor hover:bg-primaryColor text-white font-bold py-2 px-3 rounded-full focus:outline-none focus:shadow-outline"
                onClick={onClose}
              >
                Cancel
              </button>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

const styles = {
  modal: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '5px',
    textAlign: 'center',
  },
  button: {
    margin: '10px',
    padding: '10px 20px',
    fontSize: '16px',
    cursor: 'pointer',
  }
};

export default ResetPortfolioModal;
